import React from "react";

import styles from "./BasicText.module.scss";

type Props = {
  title: string;
  text: string;
  children?: JSX.Element;
};

const BasicText: React.FC<Props> = ({ title, text, children }) => {
  return (
    <div className={styles["f-basicText"]}>
      <h3 className={styles["f-basicText__title"]}>{title}</h3>
      <p className={styles["f-basicText__text"]}>{text}</p>
      {children}
    </div>
  );
};

export default BasicText;
